import styled from 'styled-components';

/**
 * Container de estado vazio
 */
export const EmptyState = styled.div`
    width: 100%;
    box-sizing: border-box;
    padding: ${(props) => props.padding || '64px 48px'};
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    font-family: 'Mulish', sans-serif;
`;

/**
 * Título do estado vazio
 */
export const EmptyTitle = styled.h3`
    font-size: ${(props) => props.fontSize || '20px'};
    font-weight: 700;
    color: #2c3e50;
    margin: 0 0 8px 0;
    font-family: 'Mulish', sans-serif;
`;

/**
 * Texto do estado vazio
 */
export const EmptyText = styled.p`
    font-size: ${(props) => props.fontSize || '14px'};
    color: #7f8c8d;
    margin: 0;
    max-width: ${(props) => props.maxWidth || '400px'};
    line-height: 1.5;
    font-family: 'Mulish', sans-serif;
`;

/**
 * Ícone do estado vazio
 */
export const EmptyIcon = styled.div`
    font-size: 48px;
    color: #cbd5e1;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
`;
